import React from 'react';
import { createRoot } from 'react-dom/client';
import initI18n from './utils/i18n';
import IndexView from './views/IndexView';
import Analytics from './Analytics';
import newRelicWrapper from './newRelicWrapper';
import App from './app';

let trackingInitialized = false;
const container = document.getElementById('app');
const root = createRoot(container);

initI18n();
function startUp() {
  if (!trackingInitialized) {
    root.render(<App pageName="Albelli:IndexPage"><IndexView /></App>);
    trackingInitialized = true;
  }
}

window.addEventListener('trackingReady', () => {
  startUp();
});

const trackingNode = document.getElementById('tracking-div');
// add swan class to the consent-manager container since it is
// outside of the swan wrapped "app" and styles do not get applied
trackingNode.classList.add('swan');
const trackingRoot = createRoot(trackingNode);
trackingRoot.render(<Analytics />);

const timeout = setTimeout(() => {
  if (!trackingInitialized) {
    startUp();
    newRelicWrapper.noticeError('Could not initialize tracking for albelli index page');
  }
  window.clearTimeout(timeout);
}, 5000);
